import { render, staticRenderFns } from "./DrawFence.vue?vue&type=template&id=b8cdb234&scoped=true&"
import script from "./DrawFence.vue?vue&type=script&lang=js&"
export * from "./DrawFence.vue?vue&type=script&lang=js&"
import style0 from "./DrawFence.vue?vue&type=style&index=0&id=b8cdb234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cdb234",
  null
  
)

export default component.exports